import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LanguageState } from '@store/states/language.state';

const languageSelector = createFeatureSelector<LanguageState>('language');

export const languageSelectors = {
  currentLanguage: createSelector(languageSelector, (state) => state.lang),
  visibilityLang: createSelector(languageSelector, (state) => state.visibilityLang),
};
